import { createFileRoute } from '@tanstack/react-router';
import { ReimbursementLimitTable } from '@/modules/reimbursement-limit';

export const Route = createFileRoute('/(dashboard)/_dashboard/finance/reimbursement/$id/employee')({
  component: ReimbursementLimitTable,
});
